module.exports = __webpack_public_path__ + "static/media/filter-icon.f8d88e48.svg";